import { Link, withRouter } from 'react-router-dom';

import { getMessage } from 'common/helpers/miscHelper';

const ContinueAsGuest = (props) => {
  const { match, settings } = props;
  const { slug } = match.params;
  return (
    <div className="c7-account-login--new">
      <h4>Continue as guest</h4>
      <p>{getMessage('Club Signup Create Account', settings)}</p>
      <p>
        <Link to={`/club/${slug}/signup`} className="c7-button">
          Continue as guest
        </Link>
      </p>
    </div>
  );
};

export default withRouter(ContinueAsGuest);
